export const MAX_FONT_SIZE = 20;
export const MIN_FONT_SIZE = 5;

export const XS_SIZE = 800;

export const TIMES = {
  TODAY: 1,
  ONE_WEEK: 2,
  ONE_MONTH: 3,
  YEAR_TO_DATE: 4,
};

export const mapTimesToValue = {
  [TIMES.TODAY]: 'today',
  [TIMES.ONE_WEEK]: 'oneWeek',
  [TIMES.ONE_MONTH]: 'oneMonth',
  [TIMES.YEAR_TO_DATE]: 'yearToDate',
};
